import { z } from 'zod'

const pageSizeSchema = z.coerce
  .number()
  .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
  .catch(10)

export const edyEduOrganizationSearchSchema = z.object({
  tab: z.enum(['institutions', 'goLive']).catch('institutions'),
  search: z.string().max(200).optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: pageSizeSchema,
  sortBy: z.enum(['name', 'enduserno', 'regno', 'activeinternships', 'usercount']).catch('name'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
  goLivePage: z.coerce.number().int().min(1).catch(1),
  goLivePageSize: pageSizeSchema,
  goLiveSortBy: z.enum(['requestedat', 'orgname']).catch('requestedat'),
  goLiveDirection: z.enum(['asc', 'desc']).catch('desc'),
})

export type EdyEduOrganizationSearch = z.infer<typeof edyEduOrganizationSearchSchema>

export const defaultEdyEduOrganizationSearch: EdyEduOrganizationSearch = {
  tab: 'institutions',
  page: 1,
  pageSize: 10,
  sortBy: 'name',
  direction: 'asc',
  goLivePage: 1,
  goLivePageSize: 10,
  goLiveSortBy: 'requestedat',
  goLiveDirection: 'desc',
}
